module.exports = __webpack_public_path__ + "667ce732707efae02e07f118c7cb6e39.svg";